/**
 * The slider's skin.
 *
 * Built on the NATIVE `<input type="range">`, deliberately, for the reason
 * `DatePicker` is built on the native date input: the browser already gives us
 * keyboard operation, drag, touch, the correct value semantics **and — the part
 * a hand-built slider always gets wrong — the mirrored direction in RTL**. What
 * it does not give us is a look, so the track and the fill are drawn UNDER the
 * input as two boxes positioned with logical properties, and only the thumb is
 * styled through the vendor pseudo-elements (in `globals.css`, where the
 * scrollbar treatment lives for the same reason: a pseudo-element cannot be
 * addressed from a class).
 *
 * The fill's width is the one inline style in the family — genuine runtime data,
 * which U6 exempts, and it uses `inline-size` + `start-0` so RTL needs no branch.
 */

/** Positions the two painted boxes behind the input; sized to hold the thumb. */
export const SLIDER_ROOT_CLASSES = 'relative flex h-lg w-full items-center';

export const SLIDER_TRACK_CLASSES =
  'pointer-events-none absolute start-0 end-0 h-xs rounded-full bg-muted';

export const SLIDER_FILL_CLASSES =
  'pointer-events-none absolute start-0 h-xs rounded-full bg-primary';

/**
 * The input itself: transparent, so the boxes behind it show through, and
 * carrying the hook `globals.css` styles the thumb from.
 */
export const SLIDER_INPUT_CLASSES =
  'kit-slider relative h-lg w-full cursor-pointer appearance-none bg-transparent focus-visible:outline-none disabled:cursor-not-allowed disabled:opacity-60';
